import React, { useState } from 'react';
import { ChevronDown, ChevronUp, ListChecks } from 'lucide-react';

const Row = ({ k, v }) => (
  <div className="flex gap-2 text-xs">
    <span className="w-40 shrink-0 text-slate-500">{k}</span>
    <span className="text-slate-800 font-medium">{Array.isArray(v) ? v.join(', ') : (v || 'Open / not specified')}</span>
  </div>
);

const short = (v) => (Array.isArray(v) ? v.join(' / ') : v) || 'Open';

export const BriefCard = ({ brief, compact = true }) => {
  const [open, setOpen] = useState(!compact);
  if (!brief) return null;
  const line = [
    brief.technology_delivery || brief.focus_label,
    short(brief.opportunity_types),
    short(brief.business_models),
    brief.manufacturing && !/open/i.test(brief.manufacturing) ? brief.manufacturing : null,
    `TA: ${short(brief.therapeutic_area)}`,
    `Stage: ${short(brief.development_stage)}`,
    brief.geography || 'Global',
  ].filter(Boolean).join(' · ');
  return (
    <div className="rounded-lg border border-sky-200 bg-sky-50/60 px-3 py-2" data-testid="discovery-brief">
      <button onClick={() => setOpen(o => !o)} className="w-full flex items-start gap-2 text-left" data-testid="brief-toggle">
        <ListChecks className="w-3.5 h-3.5 text-sky-700 mt-0.5 shrink-0" />
        <span className="text-xs text-slate-800 flex-1"><span className="font-bold">Read as:</span> {line}</span>
        {open ? <ChevronUp className="w-3.5 h-3.5 text-slate-400 shrink-0" /> : <ChevronDown className="w-3.5 h-3.5 text-slate-400 shrink-0" />}
      </button>
      {open && (
        <div className="mt-2 grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-1">
          <Row k="Technology / Delivery" v={brief.technology_delivery} />
          <Row k="Opportunity type" v={brief.opportunity_types} />
          <Row k="Business model" v={brief.business_models} />
          <Row k="Manufacturing" v={brief.manufacturing} />
          <Row k="Therapeutic area" v={brief.therapeutic_area} />
          <Row k="Indication" v={brief.indication} />
          <Row k="Development stage" v={brief.development_stage} />
          <Row k="Geography" v={brief.geography} />
          <div className="md:col-span-2"><Row k="Objective" v={brief.objective} /></div>
          {Array.isArray(brief.strong_terms) && brief.strong_terms.length > 0 && (
            <div className="md:col-span-2 text-[10px] text-slate-500 mt-1">
              <span className="font-semibold">Strong evidence terms:</span> {brief.strong_terms.join(' · ')}
              {Array.isArray(brief.adjacent_terms) && brief.adjacent_terms.length > 0 && <> &nbsp;·&nbsp; <span className="font-semibold">Adjacent:</span> {brief.adjacent_terms.join(' · ')}</>}
            </div>
          )}
        </div>
      )}
    </div>
  );
};
